import React from 'react';
import { Typography, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import SangerSequenceAnalyzer from '../../components/results/SangerSequenceAnalyzer';

const { Title } = Typography;

export default function SangerAnalysisPage() {
  const navigate = useNavigate();
  return (
    <div>
      <Button
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate('/cloning')}
        style={{ marginBottom: 16 }}
      >
        返回分子克隆
      </Button>
      <Title level={2}>Sanger测序分析</Title>
      <SangerSequenceAnalyzer />
      </div>
  );
}
